import React, { useEffect, useState } from 'react';
import MapWithAutoComplete from '../../components/MapComponent';
import { useMutation } from '@tanstack/react-query';
import toast, { LoaderIcon } from 'react-hot-toast';
import { Button, Text, TextInput } from '@mantine/core';
import { cn } from '../../lib/utils';
import useFormData from '../../hooks/useFormData';
import Loader from '../../components/Loader';
import { postApi } from '../../api/API';

const AvailabilityCheck = () => {
  const [address, setAddress] = useState({
    active: false,
    area_details: '',
    city: '',
    house_details: '',
    landmark: '',
    latitude: '',
    longitude: '',
    pincode: '',
    road: '',
    state: '',
  });
  const [latLng, setLatLng] = useState({
    lat: '',
    lng: '',
  });

  const [latLng1, setLatLng1] = useState({
    lat: '',
    lng: '',
  });

  const [fieldlatLng, setFieldlatLng] = useState({
    lat: '',
    lng: '',
  });

  const { mutate, data, isPending } = useMutation({
    mutationFn: ({ latitude, longitude }: { latitude: string; longitude: string }) =>
      postApi<any>({
        url: 'https://api.sharepal.in/api:AIoqxnqr/address/availability-check',
        type: 'new_admin',
        body: {
          latitude,
          longitude,
        },
      }),
    onSuccess: (data) => {},
    onError: () => {
      toast.error('Something Went Wrong');
    },
  });

  useEffect(() => {
    if (latLng.lat && latLng.lng)
      mutate({
        latitude: latLng.lat,
        longitude: latLng.lng,
      });
  }, [latLng]);

  return (
    <div>
      <div className="flex flex-col gap-2">
        {data && (
          <div className={cn('rounded-md p-4', data?.servicable ? 'bg-green-200' : 'bg-red-200')}>
            <Text>{data.servicable ? 'Address is Serviceable' : 'Address is not servicable'}</Text>
          </div>
        )}

        {isPending && <LoaderIcon className="animate-spin" />}
        <Text>Enter Latitude and Longitude for Check Avaiablity</Text>
        <div className="flex gap-5 items-end">
          <TextInput
            placeholder="Latitude"
            value={latLng1.lat}
            onChange={(e) => {
              setLatLng1((prev) => ({ ...prev, lat: e.target.value.trim() }));
            }}
          />
          <TextInput
            placeholder="Longitude"
            value={latLng1.lng}
            onChange={(e) => {
              setLatLng1((prev) => ({ ...prev, lng: e.target.value.trim() }));
            }}
          />
          <Button
            onClick={() => {
              if (latLng.lat && latLng.lng)
                mutate({
                  latitude: latLng.lat,
                  longitude: latLng.lng,
                });
              else toast.error('Please Enter Vaild Latitude and Longitude');
            }}
          >
            Check Address
          </Button>
        </div>
      </div>
      <MapWithAutoComplete
        showMap={true}
        drag={true}
        showSearchInput={true}
        showCurrentLocationButton={true}
        address={address}
        setAddress={setAddress}
        setLatLng={setLatLng}
        latLng={latLng}
        setFieldlatLng={setFieldlatLng}
      />
    </div>
  );
};

export default AvailabilityCheck;
